var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.66667H10.8333V3.83333C10.8333 3.37333 10.46 3 10 3C9.54 3 9.16667 3.37333 9.16667 3.83333V9.66667H3.33333C2.87333 9.66667 2.5 10.04 2.5 10.5C2.5 10.96 2.87333 11.3333 3.33333 11.3333H9.16667V17.1667C9.16667 17.6267 9.54 18 10 18C10.46 18 10.8333 17.6267 10.8333 17.1667V11.3333H16.6667C17.1267 11.3333 17.5 10.96 17.5 10.5C17.5 10.04 17.1267 9.66667 16.6667 9.66667Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.a185272b1e0a64f32c132d5640d400d4.svg";
export { ForwardRef as ReactComponent };